import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=3945831a&scoped=true&"
import script from "./GlobalLoading.vue?vue&type=script&lang=js&"
export * from "./GlobalLoading.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=3945831a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3945831a",
  null
  
)

component.options.__file = "GlobalLoading.vue"
export default component.exports